import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormsCircleSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFormsCircleSquare"><Path d="M18.5 8C19.8807 8 21 9.11929 21 10.5V18.5C21 19.8807 19.8807 21 18.5 21H10.5C9.11929 21 8 19.8807 8 18.5V16.9355C8.32769 16.9764 8.66123 17 9 17C13.4183 17 17 13.4183 17 9C17 8.66123 16.9764 8.32769 16.9355 8H18.5Z" fill="currentColor"/><Path d="M9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormsCircleSquare;
